// @flow

export const POST_PAY_APPLICATION_BY_METHOD: 'pay-application-by-method/post' =
  'pay-application-by-method/post';
export const GET_PAYMENT_METHOD_BY_MODEL: 'payment-method-by-model/get' =
  'payment-method-by-model/get';
export const PAYMENT_METHOD_ERROR: 'payment-method/error' =
  'payment-method/error';
export const PAYMENT_METHOD_ERROR_APP: 'payment-method-app/error' =
  'payment-method-app/error';
export const POST_PAY_BY_SR_PAGO: 'payment-method-sr-pago/error' =
  'payment-method-sr-pago/error';
export const PAY_BY_ADVANCE_SUCCESS: 'payment-method-advance/success' =
  'payment-method-advance/success';
export const PAY_BY_ADVANCE_ERROR: 'payment-method-advance/error' =
  'payment-method-advance/error';
export const GET_CONEKTA_KEY: 'conekta-key/get' = 'conekta-key/get';
export const POST_PAY_PHOTOSHOOTING: 'pay_photoshooting' = 'pay_photoshooting';
export const PAY_PHOTOSHOOTING_ERROR: 'pay_photoshooting_error' =
  'pay_photoshooting_error';
export const GET_PAYMENT_METHODS_FOOTOSHOOTING: 'payment-method_photoshooting' =
  'payment-method_photoshooting';
export const PAY_SPEI_ADVANCE_SUCCESS: 'payment-advance-method/success/spei' =
  'payment-advance-method/success/spei';

export type Action =
  | {
      type: typeof GET_PAYMENT_METHOD_BY_MODEL,
      paymentMethod: []
    }
  | {
      type: typeof POST_PAY_APPLICATION_BY_METHOD,
      payment: any
    }
  | {
      type: typeof PAYMENT_METHOD_ERROR,
      error: Error
    }
  | {
      type: typeof POST_PAY_BY_SR_PAGO,
      error: Error
    }
  | {
      type: typeof PAY_BY_ADVANCE_SUCCESS,
      payment: any
    }
  | {
      type: typeof PAY_BY_ADVANCE_ERROR,
      error: Error
    }
  | {
      type: typeof PAYMENT_METHOD_ERROR_APP,
      error: Error
    }
  | {
      type: typeof GET_CONEKTA_KEY,
      key: any
    }
  | {
      type: typeof POST_PAY_PHOTOSHOOTING,
      payment: {}
    }
  | {
      type: typeof PAY_PHOTOSHOOTING_ERROR,
      error: Error
    }
  | {
      type: typeof GET_PAYMENT_METHODS_FOOTOSHOOTING,
      paymentMethods: []
    }
  | {
      type: typeof PAY_SPEI_ADVANCE_SUCCESS,
      payment: any
    };
